<mat-card>
<mat-toolbar-row fxLayout="row" fxLayoutAlign="center center" style="padding: 0px;">
    <div fxLayout="row">
      <div class="btn-group">
        <a mat-raised-button  class="button1" [ngClass]="statusClass1"    (click)="toggleTag1()" routerLink="/workCompleted" routerLinkActive="active"  >Work Completed</a>
        <a mat-raised-button  class="button2" [ngClass]="statusClass2"  (click)="toggleTag2()"  >Work In Progress</a>
       </div>
    </div>
 </mat-toolbar-row>
<h1 class="permString" *ngIf="(showWorkCompleted && !permissionList.includes('1700005')) || (showWorkInProgress && !permissionList.includes('1700006'))" flex fxLayoutAlign="center center"><br>You don't have permission</h1>
  <div layout="row" class=margin>
   
   <div class="divclass1" style="text-align: center">
     
     <!-- <img class="imgclass1" style="vertical-align:middle" src="https://via.placeholder.com/22x22" alt="">
      -->
      <!-- <span class="inputclass1" style="vertical-align:middle">Take a photo</span> -->
     <ng-container  *ngIf="showWorkCompleted && permissionList.includes('1700005')">
      <mat-form-field  class="inputclass1" appearance="outline" [style.fontSize.px]=12>
       
         <input matInput
          placeholder=" JobId, REGONo, Date" name="searchValue"  #searchBox [(ngModel)]="searchValue" id="search-box"   >
         <!-- <mat-icon matPrefix>search</mat-icon> -->      
   <!-- <i class='fas fa-search fa-lg' matPrefix></i> -->
   <!-- <img [src]=searchimg class="iconimage"/> -->
         </mat-form-field>
         
         <button mat-stroked-button class="imgclass1" (click)="applyFilter(searchBox.value)"> <img   [src]=searchimg  class="iconimage"/></button>
              
   </ng-container>
   
   <ng-container  *ngIf="showWorkInProgress && permissionList.includes('1700006')">
      <mat-form-field appearance="outline" [style.fontSize.px]=12>
         <input matInput
          placeholder="JobId, REGONo, Date" name="searchValue"  #searchBox [(ngModel)]="searchValue" id="search-box"  (keyup)="applyFilter1(searchBox.value)" >
         <!-- <mat-icon matPrefix>search</mat-icon> -->
         </mat-form-field>
   </ng-container>
   
   </div>
   <ng-container *ngIf="showWorkCompleted && permissionList.includes('1700005')">
      <mat-form-field >
         <mat-select name="OptionsString" placeholder="JobType" [(ngModel)]="selectedJobType" (valueChange)="itemSelect($event)">
            <mat-option [value]="'ALL'">ALL</mat-option>
            <mat-option [value]="'PM'">PM</mat-option>
            <mat-option [value]="'OOS'">OOS</mat-option>
            <mat-option [value]="'TYRE'">TYRE</mat-option>
            <mat-option [value]="'FERRY'">FERRY</mat-option>
            <mat-option [value]="'BREAKDOWN'">BREAKDOWN</mat-option>
            <mat-option [value]="'SUBLET'">SUB-LET</mat-option>
            <mat-option [value]="'HANBACK/BUYBACK'">HANDBACK/BUYBACK</mat-option>
            <mat-option [value]="'RECALL/WARRANTY'">RECALL/WARRANTY</mat-option>
            <mat-option [value]="'OTHER'">OTHER</mat-option>
         </mat-select>
      </mat-form-field>
   </ng-container>
   <ng-container *ngIf="showWorkInProgress && permissionList.includes('1700006')">
      <mat-form-field >
         <mat-select name="OptionsString" placeholder="JobType" [(ngModel)]="selectedJobType" (valueChange)="itemSelect($event)">
            <mat-option [value]="'ALL'">ALL</mat-option>
            <mat-option [value]="'PM'">PM</mat-option>
            <mat-option [value]="'OOS'">OOS</mat-option>
            <mat-option [value]="'TYRE'">TYRE</mat-option>
            <mat-option [value]="'FERRY'">FERRY</mat-option>
            <mat-option [value]="'BREAKDOWN'">BREAKDOWN</mat-option>
            <mat-option [value]="'SUBLET'">SUB-LET</mat-option>
            <mat-option [value]="'HANBACK/BUYBACK'">HANDBACK/BUYBACK</mat-option>
            <mat-option [value]="'RECALL/WARRANTY'">RECALL/WARRANTY</mat-option>
            <mat-option [value]="'OTHER'">OTHER</mat-option>
         </mat-select>
      </mat-form-field>
   </ng-container>
   
      
    <h2 *ngIf="(showWorkCompleted && permissionList.includes('1700005')) || (showWorkInProgress && permissionList.includes('1700006'))" flex>Recents</h2>
  </div>
  <!--Below WorkCompleted table will display After Work Completed button clicked -->
  <div class="example-container mat-elevation-z8 " *ngIf="showWorkCompleted && permissionList.includes('1700005')">
   <table mat-table [dataSource]="dataSource"  class="mat-elevation-z8" matSort matSortActive="endtime" matSortDirection="desc">
         <ng-container matColumnDef="RepairOrderId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header >JOB </th>
           <a><td mat-cell *matCellDef="let element" (click)="getJobId(element.RepairOrderId)" routerLink="/selectFeature" >#{{element.RepairOrderId}} </td></a>
         </ng-container>
         <ng-container matColumnDef="radiobutton">
            &nbsp;
            <th mat-header-cell *matHeaderCellDef  >JOB TYPE</th>
            <td mat-cell *matCellDef="let element">{{element.radiobutton}} </td>
         </ng-container>
          <ng-container matColumnDef="REGO">
            &nbsp;
            <th mat-header-cell *matHeaderCellDef  >REGO NO</th>
            <td mat-cell *matCellDef="let element">{{element.REGO}} </td>
         </ng-container>

         <ng-container matColumnDef="endtime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>END DATE</th>
            <td mat-cell *matCellDef="let element">{{element.endtime}} </td>
         </ng-container>
         <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let element">{{element.employeeName}} </td>
         </ng-container>
         
         <!-- Added coloumn for  displaey details of perticular job details -->
         <ng-container matColumnDef="details" >
            <th mat-header-cell *matHeaderCellDef ></th>
            <td mat-cell *matCellDef="let element; let i = index;" align="end">
              <button mat-icon-button  matTooltip="Display details"
              [mdePopoverTriggerFor]="appPopover" mdePopoverTriggerOn="click"
                #popoverTrigger="mdePopoverTrigger" (click)="displayAtJobId(element.RepairOrderId)" >
                <!-- <mat-icon  [ngStyle]="{'color':'green'}">info</mat-icon> -->
                <!-- <i class='fas fa-info-circle fa-lg'  [ngStyle]="{'color':'green'}"></i> -->
                <img [src]=infoimg class="iconimage"/>
              </button>
            </td>
          </ng-container>
          
         <ng-container matColumnDef="loading" >
            <td mat-footer-cell *matFooterCellDef  colspan="6">
               Loading data...
            </td>
         </ng-container>

           <tr mat-header-row *matHeaderRowDef="displayedColumnsWC; sticky: true"></tr>
           <tr mat-row *matRowDef="let row; columns: displayedColumnsWC;"  ></tr>
           <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSource!=null}"></tr>
       </table>

   <!-- <mat-paginator [pageSizeOptions]="[7,10,15]"  showFirstLastButtons></mat-paginator> -->
</div>

<!-- Below table display After Work In progress but clicked -->
 <div class="example-container mat-elevation-z8" *ngIf="showWorkInProgress && permissionList.includes('1700006')">

      <table mat-table [dataSource]="dataSource1"  class="mat-elevation-z8" matSort matSortActive="starttime" matSortDirection="desc">
         <ng-container matColumnDef="RepairOrderId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>JOB ID</th>
          <a><td mat-cell *matCellDef="let element" (click)="getJobId(element.RepairOrderId)" routerLink="/selectFeature" >#{{element.RepairOrderId}}</td></a>

         </ng-container>
         <ng-container matColumnDef="radiobutton">
            &nbsp;
            <th mat-header-cell *matHeaderCellDef  >JOB TYPE</th>
            <td mat-cell *matCellDef="let element">{{element.radiobutton}} </td>
         </ng-container>
          <ng-container matColumnDef="REGO">
            <th mat-header-cell *matHeaderCellDef >REGO NO</th>
            <td mat-cell *matCellDef="let element">{{element.REGO}} </td>
         </ng-container>

         <ng-container matColumnDef="starttime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>START DATE</th>
            <td mat-cell *matCellDef="let element">{{element.starttime}}</td>
         </ng-container>
         <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let element">{{element.employeeName}} </td>
         </ng-container>
         
         <ng-container matColumnDef="details">
            <th mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let element; let i = index;"  align="end">
              <button mat-icon-button  matTooltip="Display details"  [mdePopoverTriggerFor]="appPopover"
                  mdePopoverTriggerOn="click" #popoverTrigger="mdePopoverTrigger" (click)="displayAtJobId(element.RepairOrderId)" >
                  <!-- <mat-icon [ngStyle]="{'color':'green'}">info</mat-icon> -->
                 <!-- <i class='fas fa-info-circle fa-lg'  [ngStyle]="{'color':'green'}"></i>-->
                 <img [src]=infoimg class="iconimage"/>
               </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="loading" >
              <td mat-footer-cell *matFooterCellDef  colspan="6">
                 Loading data...
              </td>
         </ng-container>
         <tr mat-header-row *matHeaderRowDef="displayedColumnsWIP; sticky: true" ></tr>
         <tr mat-row *matRowDef="let row; columns: displayedColumnsWIP;" class="example-element-row"></tr>
        <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSource!=null}"></tr> 
       </table>
   </div>
   <mat-paginator *ngIf="(showWorkCompleted && permissionList.includes('1700005')) || (showWorkInProgress && permissionList.includes('1700006'))" [pageSizeOptions]="[10,15,20]"  showFirstLastButtons></mat-paginator>

<mde-popover #appPopover="mdePopover" [mdePopoverOverlapTrigger]="false">
   <mat-card >
     <mat-card-content>
      <table class="table table-striped">
         <thead>
           <tr>

           </tr>
         </thead>
         <ng-container >
            <tbody>
               MVA : {{MVA}}<br>
               Model : {{model}}<br>
               Category : {{radiobutton}}
            </tbody>
          </ng-container>
     </table>
     </mat-card-content>
   </mat-card>
 </mde-popover>
</mat-card>